"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var inversify_react_1 = require("inversify-react");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var PlanGroupTabs_1 = require("QuoteV2/Components/PlanGroupTabs");
var DiscountPanel_1 = require("./DiscountPanel");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var DiscountEditor_1 = require("../SettingsMenus/DiscountEditor/DiscountEditor");
var StringManipulater_1 = require("Utils/StringManipulater");
var c = (0, BemBuilder_1.default)("plan-group-edit-popover");
var PlanSectionEditGroupMenu = (function (_super) {
    __extends(PlanSectionEditGroupMenu, _super);
    function PlanSectionEditGroupMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.isOpen = false;
        var groupDiscount = props.groupDiscount;
        if (!groupDiscount) {
            _this.discountSelectionState = DiscountPanel_1.DiscountSelectionState.None;
        }
        else if (groupDiscount.isSavedType()) {
            _this.discountSelectionState = DiscountPanel_1.DiscountSelectionState.Saved;
        }
        else {
            _this.discountSelectionState = DiscountPanel_1.DiscountSelectionState.Custom;
        }
        return _this;
    }
    PlanSectionEditGroupMenu.prototype.updateBillingFrequencyByGroup = function (frequency) {
        var _this = this;
        var _a = this.props, section = _a.section, group = _a.group, onChangeGroup = _a.onChangeGroup;
        var schedule = (0, PlanGroupTabs_1.frequencyToSchedule)(frequency);
        section.itemsByGroup(group).forEach(function (item) {
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                if ((0, Types_1.isRecurringSchedule)(schedule)) {
                    item.setRecurringFrequency(schedule.frequency);
                }
                else {
                    item.setOneOffSchedule();
                }
                _this.quoteTelemetry.trackPlanSectionAddFrequencyGroup((0, PlanGroupTabs_1.scheduleToFrequency)(group));
            }
        });
        onChangeGroup(schedule);
    };
    PlanSectionEditGroupMenu.prototype.removeDiscountByGroup = function () {
        var _a = this.props, section = _a.section, group = _a.group;
        section.itemsByGroup(group).forEach(function (item) {
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                item.discount.disableDiscount();
            }
        });
    };
    PlanSectionEditGroupMenu.prototype.applyCustomDiscountByGroup = function (unit, type) {
        var _this = this;
        var _a = this.props, section = _a.section, group = _a.group;
        section.itemsByGroup(group).forEach(function (item) {
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                item.discount.setCustomDiscount(unit, type);
                _this.quoteTelemetry.trackDiscountApplied(QuoteTelemetry_1.QuoteTelemetryHierarchy.PlanCard, "one-off");
            }
        });
    };
    PlanSectionEditGroupMenu.prototype.applySavedDiscountByGroup = function (id) {
        var _this = this;
        var _a = this.props, section = _a.section, group = _a.group;
        section.itemsByGroup(group).forEach(function (item) {
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                item.discount.setSavedDiscount(id);
                _this.quoteTelemetry.trackDiscountApplied(QuoteTelemetry_1.QuoteTelemetryHierarchy.PlanCard, "saved");
            }
        });
    };
    PlanSectionEditGroupMenu.prototype.handleChangeDiscountSelection = function (discountSelectionState) {
        if (this.discountSelectionState === discountSelectionState) {
            return;
        }
        this.discountSelectionState = discountSelectionState;
        if (discountSelectionState === DiscountPanel_1.DiscountSelectionState.None) {
            this.removeDiscountByGroup();
            this.quoteTelemetry.trackDiscountApplied(QuoteTelemetry_1.QuoteTelemetryHierarchy.PlanCard, "none");
        }
        else if (discountSelectionState === DiscountPanel_1.DiscountSelectionState.Saved) {
            this.removeDiscountByGroup();
        }
        else if (discountSelectionState === DiscountPanel_1.DiscountSelectionState.Custom) {
            this.applyCustomDiscountByGroup(0, Types_1.DiscountType.Percent);
        }
    };
    Object.defineProperty(PlanSectionEditGroupMenu.prototype, "hasSavedDiscounts", {
        get: function () {
            var savedDiscounts = this.discountService.getAllLiveDiscounts();
            return savedDiscounts && savedDiscounts.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    PlanSectionEditGroupMenu.prototype.renderCustomDiscounts = function () {
        var _this = this;
        var groupDiscount = this.props.groupDiscount;
        return (react_1.default.createElement("div", { className: c("custom-discount") },
            react_1.default.createElement(NumberInput_1.default, { label: "Discount amount", labelHidden: true, variant: kaleidoscope_1.TextInputVariant.Bordered, size: kaleidoscope_1.TextInputSize.Medium, value: groupDiscount ? groupDiscount.units : 0, onChange: function (value) {
                    _this.applyCustomDiscountByGroup(value, groupDiscount ? groupDiscount.type : Types_1.DiscountType.Percent);
                }, type: kaleidoscope_1.TextInputType.Number, endElement: react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Discount type", labelHidden: true, size: kaleidoscope_1.SegmentedControlSize.Medium, onClickHandler: function (type) {
                        _this.applyCustomDiscountByGroup(groupDiscount ? groupDiscount.units : 0, type);
                    }, options: [
                        {
                            label: "%",
                            value: Types_1.DiscountType.Percent,
                        },
                        {
                            label: this.quoteCurrencyFormatter.getSymbol(),
                            value: Types_1.DiscountType.Fixed,
                        },
                    ], selectedValue: groupDiscount ? groupDiscount.type : Types_1.DiscountType.Percent }) })));
    };
    PlanSectionEditGroupMenu.prototype.renderSavedDiscounts = function () {
        var _this = this;
        var _a;
        var groupDiscount = this.props.groupDiscount;
        var savedDiscounts = this.discountService.getAllLiveDiscounts();
        var name = groupDiscount === null
            ? null
            :
                (_a = savedDiscounts.find(function (discount) {
                    if (groupDiscount) {
                        return discount.id === groupDiscount.id;
                    }
                })) === null || _a === void 0 ? void 0 : _a.name;
        return (react_1.default.createElement("div", { className: c("custom-discount") },
            this.discountSelectionState === DiscountPanel_1.DiscountSelectionState.Saved && this.hasSavedDiscounts && (react_1.default.createElement(kaleidoscope_1.Dropdown, { name: name, placeholder: "Select Discount", size: kaleidoscope_1.DropdownSize.Small }, savedDiscounts.map(function (discount) { return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { key: discount.id, name: discount.name, selected: discount.id === (groupDiscount === null || groupDiscount === void 0 ? void 0 : groupDiscount.id), onSelect: function () {
                    _this.applySavedDiscountByGroup(discount.id);
                } })); }))),
            this.discountSelectionState === DiscountPanel_1.DiscountSelectionState.Saved && !this.hasSavedDiscounts && (react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Use discounts regularly?", alertType: kaleidoscope_1.AlertType.Info, alignment: kaleidoscope_1.AlertAlignment.Center }, "Add saved discounts below to reuse them and save time when creating quotes."))));
    };
    PlanSectionEditGroupMenu.prototype.renderGroupDiscountPanel = function () {
        var _this = this;
        return (react_1.default.createElement("div", { className: c("group-discount-panel") },
            react_1.default.createElement(kaleidoscope_1.SegmentedControl, { label: "Discount", onClickHandler: function (next) { return _this.handleChangeDiscountSelection(next); }, options: [
                    {
                        label: "None",
                        value: DiscountPanel_1.DiscountSelectionState.None,
                    },
                    {
                        label: "Saved",
                        value: DiscountPanel_1.DiscountSelectionState.Saved,
                    },
                    {
                        label: "Custom",
                        value: DiscountPanel_1.DiscountSelectionState.Custom,
                    },
                ], selectedValue: this.discountSelectionState }),
            this.discountSelectionState === DiscountPanel_1.DiscountSelectionState.Custom && this.renderCustomDiscounts(),
            this.discountSelectionState === DiscountPanel_1.DiscountSelectionState.Saved && this.renderSavedDiscounts(),
            react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () {
                    _this.discountEditor.show(_this.quoteCurrencyFormatter);
                }, type: kaleidoscope_1.ButtonType.Secondary, width: "full" },
                this.hasSavedDiscounts ? "Manage" : "Add",
                " discounts")));
    };
    PlanSectionEditGroupMenu.prototype.deleteItemsByGroup = function () {
        var _a = this.props, section = _a.section, group = _a.group;
        section.itemsByGroup(group).forEach(function (item) {
            section.deleteLineItem(item);
        });
        this.quoteTelemetry.trackPlanSectionDeleteFrequencyGroup((0, PlanGroupTabs_1.scheduleToFrequency)(group));
    };
    PlanSectionEditGroupMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, section = _a.section, group = _a.group;
        return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, isOpen: this.isOpen, onChange: function (open) { return (_this.isOpen = open); }, className: c(), button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Edit, null), tooltip: {
                    content: "".concat((0, StringManipulater_1.titleCase)((0, PlanGroupTabs_1.scheduleToFrequency)(group)), " group options"),
                }, className: c("button") }, buttonProps))); } },
            react_1.default.createElement("div", { className: c("panel-content") },
                react_1.default.createElement(kaleidoscope_1.Dropdown, { label: "Billing frequency", name: (0, StringManipulater_1.titleCase)((0, PlanGroupTabs_1.scheduleToFrequency)(group)), size: kaleidoscope_1.DropdownSize.Medium },
                    react_1.default.createElement(kaleidoscope_1.DropdownItem, { name: "One off", onSelect: function () {
                            _this.updateBillingFrequencyByGroup("one off");
                        } }),
                    Object.values(Types_1.RecurringFrequency).map(function (frequency) { return (react_1.default.createElement(kaleidoscope_1.DropdownItem, { key: frequency, name: frequency, onSelect: function () {
                            _this.updateBillingFrequencyByGroup(frequency);
                        } })); })),
                this.renderGroupDiscountPanel(),
                react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, width: "full", type: kaleidoscope_1.ButtonType.Secondary, disabled: section.groups.length === 1, onClick: function () { return _this.deleteItemsByGroup(); } },
                    react_1.default.createElement(icons_1.Delete, null),
                    "Delete group"))));
    };
    var _a, _b, _c, _d, _e, _f;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _a : Object)
    ], PlanSectionEditGroupMenu.prototype, "quoteTelemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_b = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _b : Object)
    ], PlanSectionEditGroupMenu.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discountService"),
        __metadata("design:type", typeof (_c = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _c : Object)
    ], PlanSectionEditGroupMenu.prototype, "discountService", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_d = typeof DiscountEditor_1.DiscountEditor !== "undefined" && DiscountEditor_1.DiscountEditor) === "function" ? _d : Object)
    ], PlanSectionEditGroupMenu.prototype, "discountEditor", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanSectionEditGroupMenu.prototype, "isOpen", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_e = typeof DiscountPanel_1.DiscountSelectionState !== "undefined" && DiscountPanel_1.DiscountSelectionState) === "function" ? _e : Object)
    ], PlanSectionEditGroupMenu.prototype, "discountSelectionState", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_f = typeof DiscountPanel_1.DiscountSelectionState !== "undefined" && DiscountPanel_1.DiscountSelectionState) === "function" ? _f : Object]),
        __metadata("design:returntype", void 0)
    ], PlanSectionEditGroupMenu.prototype, "handleChangeDiscountSelection", null);
    PlanSectionEditGroupMenu = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], PlanSectionEditGroupMenu);
    return PlanSectionEditGroupMenu;
}(react_1.default.Component));
exports.default = PlanSectionEditGroupMenu;
